import { useEffect, useRef } from "react";
import { useCities } from "../providers/CitiesContext";
import "../styles/Notifications.css";

export default function Notifications({
  items,
  onClose,
  onOpen,
  injectStyles = false,
  position = "top-right",
  autoCloseMs = 3000,
}) {
  const timersRef = useRef(new Map());

  // 👇 словарь: { moscow: "Москва", spb: "Санкт-Петербург", ... }
  const { cityNameByKey } = useCities();

  useEffect(() => {
    if (!injectStyles) return;
    const id = "ntf-styles";
    if (document.getElementById(id)) return;
    const el = document.createElement("style");
    el.id = id;
    el.textContent = CSS;
    document.head.appendChild(el);
  }, [injectStyles]);

  useEffect(() => {
    const timers = timersRef.current;

    items.forEach((n) => {
      if (!timers.has(n.id)) {
        const t = setTimeout(() => {
          timers.delete(n.id);
          onClose?.(n.id);
        }, autoCloseMs);

        timers.set(n.id, t);
      }
    });

    for (const [id, t] of timers) {
      if (!items.find((n) => n.id === id)) {
        clearTimeout(t);
        timers.delete(id);
      }
    }

    return () => {
      for (const [, t] of timers) {
        clearTimeout(t);
      }

      timers.clear();
    };
  }, [items, autoCloseMs, onClose]);

  const wrapStyle = {};
  if (position === "bottom-center") {
    wrapStyle.top = "auto";
    wrapStyle.bottom = 12;
    wrapStyle.right = "50%";
    wrapStyle.transform = "translateX(50%)";
    wrapStyle.width = "min(92vw, 420px)";
    wrapStyle.alignItems = "flex-end";
  }

  return (
    <div className="toasts-wrap" style={wrapStyle} aria-live="polite" aria-atomic="true">
      {items.map((n) => {
        const title =
          n.kind === "insert"
            ? "🆕 Добавлен новый ЖК"
            : n.kind === "enabled"
            ? n.enabled
              ? "✅ ЖК включён"
              : "❌ ЖК выключен"
            : "ℹ️ Обновление ЖК";

        const classes = ["toast"];
        if (n.kind === "enabled") classes.push("enabled");
        if (n.enabled === false) classes.push("off");

        // 👇 приводим ключ к нижнему регистру/без пробелов и ищем русское имя
        const cityKey = typeof n.city === "string" ? n.city.trim().toLowerCase() : "";
        const cityRu = cityNameByKey[cityKey] ?? (n.city || "");

        return (
          <div
            key={n.id}
            className={classes.join(" ")}
            role="status"
            style={{ "--ttl": `${autoCloseMs}ms` }}
          >
            <button
              className="toast-x"
              onClick={() => onClose?.(n.id)}
              aria-label="Закрыть уведомление"
              title="Закрыть"
            >
              ×
            </button>

            <div className="toast-title">{title}</div>

            <div className="toast-body">
              {n.name || "Без названия"}
              {cityRu ? ` • ${cityRu}` : ""}
            </div>

            <div className="toast-progress" />
          </div>
        );
      })}
    </div>
  );
}
